import React, { useMemo } from "react";
import UserContext from "./UserContext";
import useAuthorizationHeader from "./hooks/useAuthorizationHeader";
import useFreshUser from "./hooks/useFreshUser";
import useTokenAndUserState from "./hooks/useTokenAndUserState";

function UserProvider({ children }) {
    const {
        initialized,
        setInitialized,
        user,
        setUser,
        accessToken,
        setAccessToken,
    } = useTokenAndUserState();

    useAuthorizationHeader(accessToken);
    const { loading: isLoadingSession } = useFreshUser(
        initialized,
        accessToken,
        setUser
    );

    const contextValue = useMemo(
        () => ({
            setInitialized: setInitialized,
            user: user,
            setUser: setUser,
            accessToken: accessToken,
            setAccessToken: setAccessToken,
        }),
        [setInitialized, user, setUser, accessToken, setAccessToken]
    );

    if (!initialized || isLoadingSession) {
        return null;
    }

    return (
        <UserContext.Provider value={contextValue}>
            <>{children}</>
        </UserContext.Provider>
    );
}

export default UserProvider;
